import { ObservableService } from "../services/ObservableService";

const initialState = {
  mapping : {},
  selectedIndicador: 0,
};

export const statesStore = ObservableService.persistentObservable(
  "statesStore",
  () => initialState,
  3600
);
